import { createContext, useContext } from 'react'

export const AppointmentTypeContext = createContext()

export const AppointmentTypeProvider = ({ appointmentType, children }) => {
  return (
    <AppointmentTypeContext.Provider value={appointmentType}>
      {children}
    </AppointmentTypeContext.Provider>
  )
}

export const withAppointmentType =
  (Component) =>
  ({ appointmentType, ...props }) => (
    <AppointmentTypeProvider appointmentType={appointmentType}>
      <Component {...props} />
    </AppointmentTypeProvider>
  )

export const useAppointmentType = () => useContext(AppointmentTypeContext)
